// Module 0 · m0-3 — client for the /api/setup surface (tenant onboarding wizard).
// The server derives each step from real tenant data and stamps activation; this is a plain read.
// Mirrors the api/crm.ts fn style: typed shapes + standalone fn(api, …) returning the unwrapped data.
import type { ApiClient } from './client'

export type SetupStepKey = 'org' | 'employees' | 'menu' | 'integrations' | 'payroll' | 'firstEntry'

export interface SetupStep {
  key: SetupStepKey
  label: string
  completed: boolean
  completedAt: string | null
  /** One of the four steps that gate activation; `integrations` is optional (false). */
  core: boolean
}

export interface SetupChecklistState {
  steps: SetupStep[]
  activated: boolean
  activatedAt: string | null
}

export async function fetchSetupChecklist(api: ApiClient): Promise<SetupChecklistState> {
  const res = await api.get<{ data: SetupChecklistState }>('/setup/checklist')
  return res.data
}
